var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQualDoc(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 77,
    viewBox: "0 0 72 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_545_31838)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_545_31838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6.27832C4 4.06918 5.79086 2.27832 8 2.27832H54.5391C56.7483 2.27832 58.5391 4.06918 58.5391 6.27832V36.7574V41.374V45.4088V62.0001C58.5391 64.2092 56.7483 66.0001 54.5391 66.0001H8C5.79086 66.0001 4 64.2092 4 62.0001V6.27832Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 43,
    height: 28,
    fill: "#F0FDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 3.34315 5.34315 2 7 2H55.5391C57.196 2 58.5391 3.34315 58.5391 5V10.3478H4V5Z",
    fill: "#AAE4EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.89526,
    y: 5.33923,
    width: 21.7043,
    height: 1.66957,
    rx: 0.834783,
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 43C38 43 36.1264 38 30.5009 38C24.8754 38 23 43 23 43H38Z",
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 34,
    width: 3,
    height: 5,
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.76 26.0078L21.2545 26.0078C19.854 26.0078 18.7188 27.1431 18.7188 28.5436V28.683C18.7188 30.0835 19.854 31.2188 21.2545 31.2188H22.7969L22.76 26.0078Z",
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.013 26.0078L39.7455 26.0078C41.146 26.0078 42.2812 27.1431 42.2812 28.5436V28.683C42.2812 30.0835 41.146 31.2188 39.7455 31.2188H37.9766L38.013 26.0078Z",
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.76 26.0078L21.2545 26.0078C19.854 26.0078 18.7188 27.1431 18.7188 28.5436V28.683C18.7188 30.0835 19.854 31.2188 21.2545 31.2188H22.7969L22.76 26.0078Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.013 26.0078L39.7455 26.0078C41.146 26.0078 42.2812 27.1431 42.2812 28.5436V28.683C42.2812 30.0835 41.146 31.2188 39.7455 31.2188H37.9766L38.013 26.0078Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9844,
    y: 22.3828,
    width: 19.0312,
    height: 13.5938,
    rx: 5,
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9479,
    y: 26.2344,
    width: 15.4062,
    height: 4.98438,
    rx: 2.49219,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5448 30.4733C27.5303 30.4733 28.3292 29.6766 28.3292 28.6937C28.3292 27.7108 27.5303 26.9141 26.5448 26.9141C25.5593 26.9141 24.7604 27.7108 24.7604 28.6937C24.7604 29.6766 25.5593 30.4733 26.5448 30.4733Z",
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5448 30.4733C27.5303 30.4733 28.3292 29.6766 28.3292 28.6937C28.3292 27.7108 27.5303 26.9141 26.5448 26.9141C25.5593 26.9141 24.7604 27.7108 24.7604 28.6937C24.7604 29.6766 25.5593 30.4733 26.5448 30.4733Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.701 30.4733C35.6865 30.4733 36.4854 29.6766 36.4854 28.6937C36.4854 27.7108 35.6865 26.9141 34.701 26.9141C33.7155 26.9141 32.9166 27.7108 32.9166 28.6937C32.9166 29.6766 33.7155 30.4733 34.701 30.4733Z",
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.701 30.4733C35.6865 30.4733 36.4854 29.6766 36.4854 28.6937C36.4854 27.7108 35.6865 26.9141 34.701 26.9141C33.7155 26.9141 32.9166 27.7108 32.9166 28.6937C32.9166 29.6766 33.7155 30.4733 34.701 30.4733Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0951 32.76C28.2398 32.5936 29.1612 33.1996 30.5313 33.1996C31.9014 33.1996 32.9583 32.5948 33.0618 32.76C33.1654 32.9252 31.9006 34.5436 30.5313 34.5436C29.1621 34.5436 27.9505 32.9264 28.0951 32.76Z",
    fill: "#4BA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0951 32.76C28.2398 32.5936 29.1612 33.1996 30.5313 33.1996C31.9014 33.1996 32.9583 32.5948 33.0618 32.76C33.1654 32.9252 31.9006 34.5436 30.5313 34.5436C29.1621 34.5436 27.9505 32.9264 28.0951 32.76Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5416 19.2109H29.959C29.959 19.2109 30.0327 20.7328 29.6979 21.4923C29.3632 22.2517 28.4609 22.6094 28.4609 22.6094H30.5416",
    fill: "#3B767B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5416 19.2109H31.1242C31.1242 19.2109 31.0505 20.7328 31.3853 21.4923C31.7201 22.2517 32.6223 22.6094 32.6223 22.6094H30.5416",
    fill: "#3B767B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 20.1172C31.2508 20.1172 31.8594 19.5086 31.8594 18.7578C31.8594 18.0071 31.2508 17.3984 30.5 17.3984C29.7492 17.3984 29.1406 18.0071 29.1406 18.7578C29.1406 19.5086 29.7492 20.1172 30.5 20.1172Z",
    fill: "#3B767B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5002 20.1176C31.2511 20.1176 31.8598 19.5089 31.8598 18.758C31.8598 18.0071 31.2511 17.3984 30.5002 17.3984C29.7493 17.3984 29.1406 18.0071 29.1406 18.758C29.1406 19.5089 29.7493 20.1176 30.5002 20.1176Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.17419,
    y: 14.687,
    width: 43.6348,
    height: 28.887,
    rx: 2,
    stroke: "#AAE4EA",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 49H37",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 54H21",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 54H43",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 54L54 54",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 58H16",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 58H25",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 58L37 58",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 58H54",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 62H21",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 62H43",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 62L54 62",
    stroke: "#7AD1D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 43.5007C67 51.5092 60.5081 58.0014 52.5 58.0014C44.4919 58.0014 38 51.5092 38 43.5007C38 35.4922 44.4919 29 52.5 29C60.5081 29 67 35.4922 67 43.5007Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3158 58.7095L61.2274 56.475L65.811 66.5513C66.2847 67.5927 65.8246 68.8209 64.7833 69.2946L63.6426 69.8136C62.6013 70.2873 61.3731 69.8271 60.8994 68.7857L56.3158 58.7095Z",
    fill: "#3B767B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 43.5007C67 51.5092 60.5081 58.0014 52.5 58.0014C44.4919 58.0014 38 51.5092 38 43.5007C38 35.4922 44.4919 29 52.5 29C60.5081 29 67 35.4922 67 43.5007Z",
    stroke: "#3B767B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3158 58.7095L61.2274 56.475L65.811 66.5513C66.2847 67.5927 65.8246 68.8209 64.7833 69.2946L63.6426 69.8136C62.6013 70.2873 61.3731 69.8271 60.8994 68.7857L56.3158 58.7095Z",
    stroke: "#3B767B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_545_31838",
    x: 0,
    y: 0,
    width: 72,
    height: 77.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.431373 0 0 0 0 0.470588 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_545_31838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_545_31838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_545_31838",
    x: 0,
    y: 0,
    width: 62.5392,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.431373 0 0 0 0 0.470588 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_545_31838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_545_31838",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualDoc);
export default __webpack_public_path__ + "assets/media/qual-doc.289f2a4d.svg";
export { ForwardRef as ReactComponent };